import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Flower from '../../../svg/Flower.js';

class Menu extends Component {
  state = {};
  render() {
    const { showMenu, isMenuAvailable } = this.props;

    return (
      <React.Fragment>
        <InfoBox
          headline="Which dishes would you like for your first week?"
          subline="Select up to six dishes 48 hours in advance of your service."
          icon={<Flower />}
        />
        <button
          onClick={showMenu}
          className="new-btn new-btn--solid-blue new-btn--full-width onboarding-new__dishes-button"
          disabled={!isMenuAvailable}
        >
          Select Dishes
        </button>
      </React.Fragment>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Menu.js